import { ExternalLink } from "lucide-react";
import { getAmazonUrl, trackAmazonClick } from "@/lib/affiliateUtils";

export default function AmazonButton({ url, productName, category, variant = "primary", className = "" }) {
  const amazonUrl = getAmazonUrl(url);

  // Never show button if no valid direct product URL
  if (!amazonUrl) {
    return null;
  }

  const handleClick = () => {
    trackAmazonClick(productName, category);
  };

  if (variant === "compact") {
    return (
      <a
        href={amazonUrl}
        target="_blank"
        rel="nofollow noopener noreferrer sponsored"
        onClick={handleClick}
        className={`inline-flex items-center gap-1.5 px-4 py-2 bg-accent text-slate-950 font-mono font-semibold text-xs rounded-lg hover:bg-amber-400 transition-all hover:shadow-md ${className}`}
      >
        Check Current Price <ExternalLink className="w-3 h-3" />
      </a>
    );
  }

  return (
    <a
      href={amazonUrl}
      target="_blank"
      rel="nofollow noopener noreferrer sponsored"
      onClick={handleClick}
      className={`inline-flex items-center justify-center gap-2 w-full px-6 py-3.5 bg-accent text-slate-950 font-heading font-bold text-sm rounded-xl hover:bg-amber-400 transition-all hover:shadow-lg hover:-translate-y-0.5 min-h-[52px] ${className}`}
    >
      Check Current Price on Amazon <ExternalLink className="w-4 h-4" />
    </a>
  );
}